
import { GridWidgetService } from '../grid-widget.services';
import { SystemService } from 'common/services/core-services/system.service';
import { GridParams } from 'common/models/utility-models/list-utility.model';
import { MetaModel } from 'common/models/utility-models/base-model';
import { Injectable } from '@angular/core';
import { TrainersViewGridDataService } from 'common/services/data-services/admin/assignment/trainers-view-grid-data.service';
import { AssignmentModel } from 'common/models/page-models/Assignments Model/assignment-data.model';
import { TrainersViewGridMetaModel } from 'common/models/page-models/Trainers View Model/trainers-view-grid-meta.model';
import { TrainersViewListingModel } from 'common/models/page-models/Trainers View Model/trainers-view-grid-params.model';


@Injectable({
    providedIn: 'root'
})
export class TrainerViewGridWidgetService extends GridWidgetService<AssignmentModel, TrainersViewListingModel> {
    constructor(protected override ds: TrainersViewGridDataService, protected systemService: SystemService) {
        super(ds);
    }

    createQueryParams(queryParam): GridParams {
        for (const key in queryParam) {
            this.queryparm[key] = queryParam[key];
        }
        return this.queryparm;
    }

   
    getMetaModel(): MetaModel {
        const meta = new TrainersViewGridMetaModel().getMetaModel();
        return meta;
    }


   

}

